import { DateTime } from 'luxon';
import { Instance, applySnapshot, flow, getParent, types } from 'mobx-state-tree';

import { readNotification } from '@common/api/notifications';

const Notification = types
	.model('Notification', {
		id: types.identifierNumber,
		created_at: types.string,
		is_important: false,
		message: types.optional(types.string, ''),
		status: types.enumeration(['sended', 'delivered', 'read']),
		title: types.optional(types.string, ''),
		updated_at: types.string,
		user_id: types.number,
		meta: types.optional(types.maybeNull(types.frozen()), null),
		is_modal: types.maybeNull(types.boolean),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views((self) => ({
		get dateTime() {
			return DateTime.fromISO(self.created_at);
		},
		get isReaded() {
			return self.status === 'read';
		},
	}))
	.views((self) => ({
		get dateString() {
			return self.dateTime.toISODate();
		},
		get timeString() {
			return self.dateTime.toLocaleString(DateTime.TIME_24_SIMPLE);
		},
	}))
	.actions((self) => ({
		read: flow(function* () {
			self.loading = true;
			try {
				const parent: any = getParent(self, 2);

				parent.decreaseUnreadCount();

				const result = yield readNotification(self.id, 'read');
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default Notification;

export interface INotificationModel extends Instance<typeof Notification> {}
